/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

'use strict';
var getWindow = require('./isWindow');

module.exports = function scrollTop(node, val) {
  var win = getWindow(node);

  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;

  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/dom-helpers/query/scrollLeft.js
 ** module id = 1376
 ** module chunks = 0
 **/